
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit, AfterViewInit, ElementRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SelectLiveBooking } from '../Models/SelectLiveBooking';
import { LiveParkflyService } from '../ApiServices/LiveParkfly.service';
import { MasterRolePermission } from '../Models/master-role-permission';
import { $$ } from 'protractor';

@Component({
  selector: 'app-parkandfly',
  templateUrl: './parkandfly.component.html',
  styleUrls: ['./parkandfly.component.css']
})
export class ParkandflyComponent implements OnInit {

  
  SelectLiveBooking: SelectLiveBooking;
  dataList: SelectLiveBooking[] = [];
  textColor: string;

  constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef, private router: Router, private LiveParkflyService: LiveParkflyService) { }


  

  ngOnInit(): void {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    } else {
      if (sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(MasterRolePermission.LiveViewParkfly.rolePermission) < 0) {
        alert("Unauthorised access");
        this.router.navigateByUrl('/index');
        return;
      } else {
         this.ShowGriddata();
      }
    } 
    setInterval(() => {
      this.ShowGriddata(); 
      }, 5000);
  }


  ShowGriddata() {
    this.LiveParkflyService.SelectLiveBooking().subscribe((dataResp) => {

      this.dataList = dataResp;
      
     
  });
  }
   setRowStyles(item: any): any {
    const currentDatetime = new Date();
    const checkinDatetime = new Date(item.CHECKIN_DATE);
 if (item.TAG_NO === null) {
      this.textColor = 'black'; 
      return { 'background-color': '#6efafa', 'color': this.textColor };
    }
 if(item.EXIT_DATETIME != null){
  this.textColor = 'black'; 
  return { 'background-color': 'red', 'color': this.textColor };

 }
 if (item.CHECKIN_DATE && checkinDatetime < currentDatetime) {
  this.textColor = 'black'; 
  return { 'background-color': '#defa6e', 'color': this.textColor };
}  
    this.textColor = 'black';
    return { 'background-color': '', 'color': this.textColor };
  }


}
